module.exports = __webpack_public_path__ + "d7b6862cebdf2df6bec9f1b29e19a7b4.png";